import React, { useContext, useState, useEffect } from 'react';
import { format, addDays } from 'date-fns';
import { Context } from '../../services/contexts/StateContext';
import api from '../../services/api';
import * as S from './styles';

import editar from '../../midia/editar.svg';
import deletVerm from '../../midia/delete.svg';
import deletAzul from '../../midia/delete_azul.svg';
import Ativar from '../../midia/ativar.svg';
import concluido from '../../midia/concluido.svg';
import icon_File from '../../midia/icon_pdf.svg';

import { FunctModal } from '../../componentes/Functions';
import { ApiEvento } from '../../services/FiltrosApi/eventoApi';
import { descricaoParaTexto } from '../../services/descricaoEventoUtil';

//-----------------------------------------------
export const ListaEventos = (props) => {
    const { state, dispatch } = useContext(Context);
    const { evento, terceiro, guincho } = state.evento;
    const { veiculo } = state.veiculo;
    const { cliente, logado } = state.cliente;
    const { parametroInit, playmodal, listaPesquisa } = state.parametros;

    const { FecharModal } = FunctModal();
    const dataAtual = new Date();
    const { BuscaTodosEventos } = ApiEvento();
    // ---------------------------------------------

    function Delete(t) {
        dispatch({
            type: 'set_Evento',
            payload: { ...evento, 'id_Evento': t._id, }
        });
        props.setAletDelete(true);
        props.setRefDelet("delete");
    }

    //----------------------------------------------
    function podeExcluir(t) {
        const idCadastro = t?.userCadastro?._id ?? t?.userCadastro;
        return logado.nivel === "master" || (!!idCadastro && String(idCadastro) === String(logado.idLogado));
    }

    function lixeira(t) {
        if (!podeExcluir(t)) return;
        dispatch({
            type: 'set_Evento',
            payload: { ...evento, 'id_Evento': t._id, }
        });
        props.setAletDelete(true);
        props.setNewStatus('E');
        props.setRefDelet("evento");
    };

    //-----------------------------------------------
    async function ativarEste() {
        await api.put(`evento/atualizarSimples/${evento.id_Evento}`, {
            status: 'A',
            logs: {
                idUsuario: logado.idLogado,
                acao: 'ativar evento',
                plataforma: "interno",
                localizacao: {
                    latitude: evento.latitude ? evento.latitude : null,
                    longitude: evento.longitude ? evento.longitude : null,
                }
            }
        })
            .then(res => {
                BuscaTodosEventos();
            })
    };

    //-----------------------------------------------
    async function Status_Concluir(t) {
        await api.put(`evento/atualizarSimples/${t._id}`, {
            status: 'C',
            logs: {
                idUsuario: logado.idLogado,
                acao: 'concluir evento',
                plataforma: "interno",
                localizacao: {
                    latitude: evento.latitude ? evento.latitude : null,
                    longitude: evento.longitude ? evento.longitude : null,
                }
            }
            
        })
            .then(() => {
                dispatch({
                    type: 'set_ListaPesquisa',
                    payload: {
                        ...listaPesquisa,
                        listaEvento: listaPesquisa.listaEvento.map(ev =>
                            ev._id === t._id ? { ...ev, status: 'C' } : ev
                        ),
                    }
                });
            })
    };

    // -----------------------------------------
    useEffect(() => {
        if (listaPesquisa.listaEvento.length > 1) {
            dispatch({
                type: 'SET_PLAYMODAL',
                payload: {
                    ...playmodal,
                    playModalDetalhesEven: false,
                }
            });
        }
    }, [listaPesquisa.listaEvento])

    //---------------------------------------------------
    function detalheEvento(t) {
        if (playmodal.playModalEven) {
            FecharModal();
        };

        dispatch({
            type: 'set_ListaPesquisa',
            payload: {
                ...listaPesquisa,
                listaEvento: [t],
            }
        });

        dispatch({
            type: 'set_cliente',
            payload: {
                ...cliente,
                id_Cliente: t?.id_Veiculo?.id_Cliente?._id,
                nome: t?.id_Veiculo?.id_Cliente?.nome,
            }
        });

        dispatch({
            type: 'set_Evento',
            payload: {
                ...evento,
                "id_Evento": t._id,
                "nomeCliente": t?.id_Veiculo?.id_Cliente?.nome,
                id_Fornecedor: t?.id_Fornecedor?._id,
                fornecedor: t?.id_Fornecedor?.nome,
                cnpjForne: t?.id_Fornecedor?.cnpj,
                chavePix: t?.id_Fornecedor?.chavePix,
                "tipo": t.tipo,
                "tipoEvento": t.tipoEvento,
                "codEvento": t.codEvento,
                "dataEvento": t.dataEvento ? String(t.dataEvento).slice(0, 10) : '',
                "ocorrenciaBO": t.ocorrenciaBO,
                "descricao": descricaoParaTexto(t.descricao),
                "descricaoOriginal": t.descricao,
                "status": t.status,
                "placa": t.placa,
                orcamento: t.orcamento ? t.orcamento : 0,
                userCadastro: t?.userCadastro?.nome,
                numeroParcelas: t.financiamento?.n_Parcelas || "",
                valorParcela: t.financiamento?.valorParcela || "",
                diaVencimento: t.financiamento?.vencimento || "",
                primeiraParcela: t.financiamento?.primeiraParcela ? format(new Date(t.financiamento.primeiraParcela), 'yyyy-MM-dd') : "",

                inicioCReserva: t.inicioCReserva ? format(new Date(t.inicioCReserva), 'yyyy-MM-dd') : '',
                fimCReserva: t.fimCReserva ? format(new Date(t.fimCReserva), 'yyyy-MM-dd') : '',

                dataPart: t.dataPart ? format(new Date(t.dataPart), 'yyyy-MM-dd') : '',
                valorPart: t.valorPart,
                detalhePart: t.detalhePart,

                dataPag: t.dataPag ? format(new Date(t.dataPag), 'yyyy-MM-dd') : "",
                valorPag: t.valorPag,
                formaPag: t.formaPag,

                arquivos: t?.arquivos.reverse()
            }
        });

        dispatch({
            type: 'set_Guincho',
            payload: { 
                ...guincho, 
                origem: t.guincho?.origem || "",
                destino: t.guincho?.destino || "",
                km: t.guincho?.km || "",
            }
        });

        dispatch({
            type: 'set_veiculo',
            payload: {
                ...veiculo,
                id_Veiculo: t?.id_Veiculo?._id,
                placa: t?.id_Veiculo?.placa,
                modelo: t?.id_Veiculo?.modelo,
                nomeCliente: t?.id_Veiculo?.id_Cliente?.nome,
                tipo: t?.id_Veiculo?.tipo,

            }
        });

        dispatch({
            type: 'SET_parametroInit',
            payload: {
                ...parametroInit,
                detalhesLista: true,
                disabledEven: true,
            }
        });

        dispatch({
            type: 'SET_PLAYMODAL',
            payload: {
                ...playmodal,
                playModalOrcamento: false,
                playModalEven: false,
                playModalDetalhesEven: playmodal.playModalDetalhesEven ? false : true,
            }
        });

        if (t.terceiro) {
            dispatch({
                type: 'set_Terceiro',
                payload: {
                    ...terceiro,
                    "tipo": t.terceiro.tipo,
                    "placa": t.terceiro.placa,
                    "chassi": t.terceiro.chassi,
                    "anoMod": t.terceiro.anoMod,
                    "montadora": t.terceiro.montadora,
                    "modelo": t.terceiro.modelo,
                    "cor": t.terceiro.cor,
                    "valorFipe": t.terceiro.valorFipe,
                    "anexoCNH": t.terceiro.anexoCNH,
                }
            });
        };
    };

    // ---------------------------------------

    function FuncNomeEvento({tipo}) {
        
        if (tipo === "Guincho_Mecanica"){
            return "Guincho Mecanica"
        };

        if (tipo === "Guincho_Eletrica"){
            return "Guincho Eletrica"
        };

        if (tipo === "Guincho_Colisao"){
            return "Guincho Colisão"
        };

        if (tipo === "Recarga"){
            return "Recarga Bateria"
        };

        if (tipo === "Reserva"){
            return "Carro Reserva"
        };

        if (tipo === "Retorno"){
            return "Retorno Domicilio"
        };

        if (tipo === "Vidro_part"){
            return "Para-brisa/vidro"
        };

        if (tipo === "Retrovisor_part"){             
            return "Retrovisor"
        };
        if (tipo === "Reparos_part"){
            return "Pequenos Reparo"
        };

        if (tipo === "Colisao_part"){
            return "Colisão"
        }else {
            return tipo
        };
    };
    // ---------------------------------------
    const [Lancamentos, setLancamentos] = useState([]);
    const [ListaAberta, setListaAberta] = useState({});

    useEffect(() => {
        const Eve = props.listaLancamento.map(e => e.eventos);
        setLancamentos(Eve.flat());
    }, [props.listaLancamento]);

    // -------Abrir Lista de Eventos-------------
    const toggleFornecedor = (index) => {
        setListaAberta(prev => ({
            ...prev,
            [index]: !prev[index]
        }));
    };


    //###################################################################
    return (
        <S.bodyresult>
            {props.listaBusca.length > 0 && 
            <>
                <S.bodyTitulo titulo={props.titulo}>
                    <span style={{color:'#83c7ffff'}} > { Lancamentos.length } </span>
                    <span className='CorTitulo'>
                        Total {props.titulo} 
                    </span>
                    <span>{parseFloat(props.SomaTotal).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}</span>
                </S.bodyTitulo>
            
            {props.listaBusca.map((e, k) => {
                return(
                <div key={k}>
                     <div 
                     onClick={() => toggleFornecedor(k)} 
                     style={{ cursor: 'pointer',backgroundColor: "#1c252c", display:"flex", justifyContent:"space-between", alignItems:"center", padding:"5px", marginTop:"2px"}}>
                        <span style={{minWidth: "150px", textTransform:"capitalize", }}>{e.nome}: </span>
                        <div style={{minWidth:"70px"}}>
                            <span 
                            style={{
                                color: props.titulo?.toLowerCase().includes('pendente') ? '#ff8787' :
                                props.titulo?.toLowerCase().includes('concluido') ? '#1fe3ab' :'#83c7ffff', 
                                marginRight:"5px"
                                }}>
                                { parseFloat(e.orcamento).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}
                            </span>
                        </div>
                    </div>
                    
                    {ListaAberta[k] && e.eventos.map((t, k2) => 
                    <S.Lista 
                        key={k2}
                        statusPG={t.valorPag && t.status === 'C'}
                        statusAberto={addDays(new Date(t.dataEvento), 7) > dataAtual}
                        statusPend={(addDays(new Date(t.dataEvento), 7) < dataAtual) && t.status !== 'C'}
                        >                        
                        <span style={{ flex:"0.5", minWidth:"65px", marginLeft: "3px" }}>
                            {evento.tipoData === "PAGAMENTO" && t.dataPag ?  format( new Date( t.dataPag ), 'dd/MM/yyyy') : format( new Date( t.dataEvento ), 'dd/MM/yyyy')}
                        </span>
                        <span style={{flex:"0.7", 'textTransform': "uppercase" }}>{t.placa}</span>

                        <span>
                            {
                                <FuncNomeEvento tipo={t.tipoEvento}/>
                            }
                        </span>
                        
                        <span style={{flex:"0.7", justifyContent: "start", color: t.orcamento ? "blue" : "black" }}>
                            {parseFloat(evento.tipoData === "PAGAMENTO" ? t.valorPag : t.orcamento || 0).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}
                        </span>
                        <span style={{minWidth:"65px", justifyContent: "end"}}>
                            {t.arquivos.length > 0 &&
                                <img
                                    className='icone'
                                    src={icon_File}
                                    onClick={() => { }}
                                    alt="icone"
                                />
                            }

                            <img
                                className='icone'
                                src={editar}
                                onClick={() => detalheEvento(t)}
                                alt="icone"
                            />

                            {t.status === 'E' &&
                                <img
                                    className='icone'
                                    src={Ativar}
                                    onClick={() => ativarEste(t)}
                                    alt="icone"
                                />
                            }

                            {podeExcluir(t) && t.status !== 'C' &&
                            <img
                                className='icone'
                                src={deletVerm}
                                onClick={() => lixeira(t)}
                                alt="icone"
                            />
                            }
                                

                            {podeExcluir(t) && logado.nivel === "master" &&
                            <>
                                <img
                                    className='icone'
                                    src={deletAzul}
                                    onClick={() => Delete(t)}
                                    alt="icone"
                                    title="Deletar Definitivo"
                                />
                                
                                <img
                                    className='icone'
                                    src={concluido}
                                    onClick={() => Status_Concluir(t)}
                                    alt="icone"
                                    title="Concluir Evento"
                                />
                            </>}
                        </span>
                    </S.Lista>
                    )}
                </div>
                )

            })}
            </>}
        </S.bodyresult>


    )
}